import React from 'react';
import MagstimTable from './MagstimTable';
import { GroupedTableWrapper}  from './GroupedTableWrapper'
import routeManager from 'RouteManager';

import {
	DateUtils,
	CurrentLang,
    isPDA
} from 'common'

import './MagstimTablePatient.css'

class MagstimTablePatient extends MagstimTable {

	initForSelect = (data, heightPx) => {
		const tableData = this.configTablePatientData(data);
		const tableDataGrouped = this.groupBySortedColumn(tableData.data, tableData.columns, tableData.columns[0]);
		tableDataGrouped.rawData = data;
		tableDataGrouped.customSortClickHandler = this.sort;
		this.initGroupedTable(tableDataGrouped, heightPx);
	}

	sort = (tableData, column, alwaysSortedColumn, direction) => {
		// console.log(`MagstimTablePatient.sort`, tableData.rawData, tableData.columns, column, alwaysSortedColumn, direction);
		const tableDataGrouped = this.groupBySortedColumn(tableData.rawData, tableData.columns, column);
		return tableDataGrouped.data;
	}

	initForEdit = (data, heightPx) => {
		this.initTable(this.configTablePatientData(data), heightPx);
	}

	configTablePatientData(data) {
		
        // See https://lucidgroup.assembla.com/spaces/magstim/tickets/realtime_list?ticket=1700
        // PII fields are only searchable now when logged is as non-MagstimAdmin user (previously you could still search for "A**" and it'd do a string match on the anonymised string)
		const isMagstimAdmin = (undefined === routeManager.isMagstimAdmin) || routeManager.isMagstimAdmin;

        var isSearchable = !isMagstimAdmin

        // For the Device - fields need to be searchable. 
        if(!isPDA()){
            isSearchable = true;
        }

		return {
			columns: [
				{ title: CurrentLang().patient_home_patient_id, property: 'PatientIdNum', isSearchable: isSearchable },
				{ title: CurrentLang().patient_home_first_name, property: 'FirstName', isPrivate: true, isSearchable: isSearchable },
				{ title: CurrentLang().patient_home_last_name, property: 'LastName', isPrivate: true, isSearchable: isSearchable },
				{ title: CurrentLang().patient_home_date_of_birth, property: 'DOB', isPrivate: true, formatter: this.formatUtcDate },
				{ title: CurrentLang().patient_home_last_treated, property: 'LastTreated', optional: true, missingData: '-', formatter: this.formatDate },
				{ title: CurrentLang().patient_home_last_treated_by, property: 'LastTreatedBy', optional: true, missingData: '-' },
				{ title: CurrentLang().patient_status, property: 'Status', alwaysSortedDirection: 1, formatter: this.formatStatus }
			],
			data: data
		};
	}

	createDictionary(data, columnName) {

		var retVal = {};

		// sort data before grouping

		var x;

		switch (columnName) {
			case 'FirstName': // Insertion row for each Character (A-Z)
			case 'LastName': // Insertion row for each Character (A-Z)
			case 'LastTreatedBy': // Insertion row for each Character (A-Z)
			case 'PatientIdNum': // Insertion row for each Alphanumeric Character (0-9, A-Z, Special)
				for (x = 0; x < data.length; x++) {
					const record = data[x]; 
					const field = record[columnName];
					const key = (null === field) ? ' ' : field.substring(0, 1).toUpperCase();
					if (undefined === retVal[key]) {
						retVal[key] = [];
					}
					retVal[key].push(record)
				}
				break;
			case 'DOB':
				for (x = 0; x < data.length; x++) {
					const record = data[x]; 
					const field = record[columnName];
					const key = '' + parseInt(Math.floor((new Date(field)).getUTCFullYear() / 10)) + '0s';
					if (undefined === retVal[key]) {
						retVal[key] = [];
					}
					retVal[key].push(record)
				}
				break;
			case 'LastTreated':
				// Insertion row for (1) Today (2) Last 7 Days (3) Last Month (4) Last Year(s)

				var groups = {};
				for (var e in DateUtils.EDateGrouping) {
					groups[DateUtils.EDateGrouping[e]] = [];
				}

				for (x = 0; x < data.length; x++) {
					const record = data[x]; 
					const field = new Date(record[columnName]);
					const key = DateUtils.getDateGrouping(field);
					groups[key].push(record)
				}

				for (e in DateUtils.EDateGrouping) {
					if (groups[DateUtils.EDateGrouping[e]].length > 0) {
						retVal[DateUtils.EDateGrouping[e]] = groups[DateUtils.EDateGrouping[e]];
					}
				}

				break;
			case 'Status':
				// Insertion row for Active or Archived
				for (x = 0; x < data.length; x++) {
					const record = data[x]; 
					const field = record[columnName];
					const key = field;
					if (undefined === retVal[key]) {
						retVal[key] = [];
					}
					retVal[key].push(record)
				}
				break;
			default:
				break;
		}

		return retVal;
	}

	groupBySortedColumn(data, columns, column) {

		column.isGrouped = true;

		const dict = this.createDictionary(data, column.property)
		
		var retVal = {columns: columns, isGrouped: true };

		retVal.data = [];
		retVal.data.isGrouped = true;

		for (const property in dict) {
			retVal.data.push({ groupName: property, data: dict[property] })
		}

		return retVal;
	}

	resetFilters() {
		// console.log('MagstimTablePatient.resetFilters');
		super.resetFilters();
		this.addFilter('Status', 'Active');
	}

	render() {

        var className = "item-margin";

        if(false === isPDA()){
            className = "item-margin device-table-wrapper";
        }

		return (
			<GroupedTableWrapper>
				<div className={className} id={this.props.div_name} ref={this._divTable} background="red" ></div>
			</GroupedTableWrapper>
		);
	}
}

export default MagstimTablePatient;